// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_loading__\\+8sj9 {
    align-items: center;
    display: flex;
    height: 80vh;
    justify-content: center;
    width: 100vw;
  }
  
  .styles_tlContainer__Hygh3 {
    align-items: center;
    border: 1px solid #2196F3;
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    overflow: auto;
    padding: 2rem;
  }
  
  .styles_tlCircle__fNan2 {
    align-items: center;
    background: #E2F2FF;
    border-radius: 50%;
    box-shadow: 1px 2px 4px #C9C9C9;
    display: flex;
    justify-content: center;
    height: 6rem;
    width: 6rem;
  }
  
  .styles_tlItem__CPBWg {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    width: 10rem;
  }
  
  .styles_tlLabel__Lw6Ca {
    background: #C0E1FC;
    border-radius: 8px;
    font-size: .8rem;
    margin-top: .5rem;
    padding: .2rem .8rem;
  }
  
  .styles_tlData__XRrJg {
    background: #E2F2FF;
    border-radius: 8px;
    font-size: .8rem;
    margin-top: .5rem;
    padding: .2rem .8rem;
  }

  @media (max-width: 530px) {
    .styles_tlContainer__Hygh3{
      flex-direction: column;
    }
    
  }`, "",{"version":3,"sources":["webpack://./src/components/ModalTimeline/styles.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,cAAc;IACd,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,+BAA+B;IAC/B,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE;MACE,sBAAsB;IACxB;;EAEF","sourcesContent":[".loading {\n    align-items: center;\n    display: flex;\n    height: 80vh;\n    justify-content: center;\n    width: 100vw;\n  }\n  \n  .tlContainer {\n    align-items: center;\n    border: 1px solid #2196F3;\n    border-radius: 8px;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-evenly;\n    overflow: auto;\n    padding: 2rem;\n  }\n  \n  .tlCircle {\n    align-items: center;\n    background: #E2F2FF;\n    border-radius: 50%;\n    box-shadow: 1px 2px 4px #C9C9C9;\n    display: flex;\n    justify-content: center;\n    height: 6rem;\n    width: 6rem;\n  }\n  \n  .tlItem {\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    text-align: center;\n    width: 10rem;\n  }\n  \n  .tlLabel {\n    background: #C0E1FC;\n    border-radius: 8px;\n    font-size: .8rem;\n    margin-top: .5rem;\n    padding: .2rem .8rem;\n  }\n  \n  .tlData {\n    background: #E2F2FF;\n    border-radius: 8px;\n    font-size: .8rem;\n    margin-top: .5rem;\n    padding: .2rem .8rem;\n  }\n\n  @media (max-width: 530px) {\n    .tlContainer{\n      flex-direction: column;\n    }\n    \n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loading": `styles_loading__+8sj9`,
	"tlContainer": `styles_tlContainer__Hygh3`,
	"tlCircle": `styles_tlCircle__fNan2`,
	"tlItem": `styles_tlItem__CPBWg`,
	"tlLabel": `styles_tlLabel__Lw6Ca`,
	"tlData": `styles_tlData__XRrJg`
};
export default ___CSS_LOADER_EXPORT___;
